import { Form } from "react-bootstrap";
import swal from "sweetalert";
import Select from "react-select";
import { selectCustomStyles } from "../../../../assets/global/selectCustomStyles";
import useDarkMode from "../../../../components/Themes/Usedarkmode";
import {
  formatToTwoDecimal,
  parseNumber,
  sanitizeAmount,
} from "../../../../utils/numberFormatter";
import { Fragment } from "react";

const ProductionFinishedCreateTable = ({
  id,
  edit,
  finishedProductRows,
  filteredFinishedProductOptions,
  stock_finish_products,
  setFinishedProductRows,
  shift,
  selectedWarehouse,
  shiftWarehouseRef,
  validated,
  setLastFocusedIndex,
  lastFocusedIndexUnitPrice,
  setLastFocusedIndexUnitPrice,
  deleteFinishedProduct,
  addNewItemFinishProduct,
}) => {
  const { themeSelectStyles } = useDarkMode();

  const addCommaToNumber = (value) => {
    if (!value && value !== 0) return "";
    const parts = String(value).split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  };

  return (
    <div className="mb-2 production-form-container-item">
      <div className="table-responsive">
        <table className="w-100 custom-datatable">
          <thead className="bg-light-custom thead-custom">
            <tr className="custom-tr">
              <th className="custom-th p-2">Finished Product</th>
              <th className="custom-th p-2">Current Stock</th>
              <th className="custom-th p-2">Qty Produce</th>
              <th className="custom-th p-2">Unit Price</th>
              <th className="custom-th p-2">Costing</th>
              <th className="custom-th p-2">UOM</th>
              <th className="custom-th p-2"></th>
            </tr>
          </thead>
          <tbody className="custom-tbody">
            {finishedProductRows.map((data, index) => {
              const finishedProductOptions = filteredFinishedProductOptions(
                index,
              ).map((item) => ({
                value: item.product_id,
                label: item.product_name,
                totalStock: item.stock_managements?.[0]?.totalStock ?? 0,
                averagePrice: item.stock_managements?.[0]?.averagePrice ?? 0,
              }));

              return (
                <Fragment key={index}>
                  <tr className="custom-tr">
                    <td className="custom-td">
                      <Select
                        options={finishedProductOptions}
                        value={
                          data.prod_id === "" || !data.prod_id
                            ? ""
                            : finishedProductOptions.find(
                                (item) => item?.value === data.prod_id,
                              )
                        }
                        onChange={(selectedOption) => {
                          const selected = selectedOption?.value;
                          const isExist = finishedProductRows.find(
                            (row) => String(row.prod_id) === String(selected),
                          );

                          if (isExist) {
                            swal({
                              title: "Oppss!",
                              text: "You cannot add product already exist",
                              icon: "error",
                              buttons: false,
                              timer: 2000,
                            });
                            return;
                          }

                          const selectedProduct = stock_finish_products.find(
                            (product) =>
                              String(product.product_id) === String(selected),
                          );

                          if (selectedProduct) {
                            const totalStock = parseFloat(
                              selectedProduct.totalStock ?? 0,
                            );
                            const averagePrice = parseFloat(
                              selectedProduct.averagePrice ?? 0,
                            );

                            setFinishedProductRows((prev) =>
                              prev.map((item, i) =>
                                i === index
                                  ? {
                                      ...item,
                                      prod_id: selectedProduct.product_id,
                                      prod_code: selectedProduct.product_code,
                                      prod_name: selectedProduct.product_name,
                                      prod_uom: selectedProduct.unit_of_measure,
                                      produce: 0,
                                      current_stock: totalStock,
                                      unit_price: averagePrice,
                                      costing: 0,
                                    }
                                  : item,
                              ),
                            );
                          }
                        }}
                        // onMenuOpen={() => {
                        //   if (!shift || !selectedWarehouse) {
                        //     swal({
                        //       icon: "warning",
                        //       title: "Missing Fields",
                        //       text: "Please complete the production details above before selecting raw materials or finished products.",
                        //     }).then(() => {
                        //       shiftWarehouseRef.current[
                        //         !shift ? 0 : 1
                        //       ].focus();
                        //       shiftWarehouseRef.current[
                        //         !shift ? 0 : 1
                        //       ].showPicker();
                        //     });
                        //     return;
                        //   }

                        //   if (stock_finish_products.length === 0) {
                        //     swal({
                        //       icon: "warning",
                        //       title: "Warning",
                        //       text: "No finished products found. Please create finished products first to proceed.",
                        //     });
                        //     return;
                        //   }
                        // }}
                        // menuIsOpen={
                        //   stock_finish_products.length === 0
                        //     ? false
                        //     : undefined
                        // }
                        menuPortalTarget={document.body}
                        placeholder={`Select Product`}
                        styles={themeSelectStyles(
                          selectCustomStyles(data.prod_id || true, validated),
                        )}
                        isDisabled={edit !== undefined ? !edit : false}
                        isSearchable
                        // required
                      />
                    </td>

                    {/* Finished Product Current Stock */}
                    <td>
                      <Form.Control
                        type="text"
                        value={formatToTwoDecimal(data.current_stock)}
                        className="form-control form-control-sm custom-input p-2"
                        readOnly
                      />
                    </td>

                    {/* Finished Product Produce */}
                    <td className="custom-td">
                      <Form.Control
                        type="text"
                        value={addCommaToNumber(data.produce)}
                        onFocus={() => setLastFocusedIndex(index)}
                        onBlur={(e) => {
                          const nextEl = e.relatedTarget;
                          if (!nextEl?.classList?.contains("swal-button")) {
                            setLastFocusedIndex(null);
                          }
                        }}
                        onChange={(e) => {
                          let value = e.target.value;
                          if (value.startsWith(".")) value = "0.00" + value;

                          const sanitized = sanitizeAmount
                            ? sanitizeAmount(value)
                            : value.replace(/[^0-9.]/g, "");
                          const [, decimalPart] = sanitized.split(".");
                          if (
                            decimalPart !== undefined &&
                            decimalPart.length > 6
                          ) {
                            swal({
                              title: "Invalid Input",
                              text: "Maximum of 6 decimal places only.",
                              icon: "warning",
                              buttons: false,
                              timer: 2000,
                            });
                            return;
                          }

                          const numericProduce = parseNumber(sanitized);
                          const numericUnitPrice = parseNumber(data.unit_price);
                          const newCosting = numericProduce * numericUnitPrice;

                          setFinishedProductRows((prevRows) =>
                            prevRows.map((item, i) =>
                              i === index
                                ? {
                                    ...item,
                                    produce: sanitized,
                                    costing: newCosting,
                                  }
                                : item,
                            ),
                          );
                        }}
                        className="form-control form-control-sm custom-input p-2"
                        readOnly={
                          edit !== undefined
                            ? !edit || !data.prod_id
                            : !data.prod_id
                        }
                      />
                    </td>

                    {/* Finished Product Unit Price */}
                    <td>
                      <Form.Control
                        type="text"
                        value={
                          lastFocusedIndexUnitPrice === index
                            ? addCommaToNumber(data.unit_price)
                            : formatToTwoDecimal(data.unit_price)
                        }
                        onFocus={() => setLastFocusedIndexUnitPrice(index)}
                        onBlur={(e) => {
                          const nextEl = e.relatedTarget;
                          if (!nextEl?.classList?.contains("swal-button")) {
                            setLastFocusedIndexUnitPrice(null);
                          }
                        }}
                        onChange={(e) => {
                          let value = e.target.value;
                          if (value.startsWith(".")) value = "0.00" + value;

                          const sanitized = sanitizeAmount
                            ? sanitizeAmount(value)
                            : value.replace(/[^0-9.]/g, "");

                          const numericUnitPrice = parseNumber(sanitized);
                          const numericProduce = parseNumber(data.produce);
                          const newCosting = numericUnitPrice * numericProduce;

                          setFinishedProductRows((prev) =>
                            prev.map((item, i) =>
                              i === index
                                ? {
                                    ...item,
                                    unit_price: sanitized,
                                    costing: newCosting,
                                  }
                                : item,
                            ),
                          );
                        }}
                        className="form-control form-control-sm custom-input p-2"
                        readOnly={
                          edit !== undefined
                            ? !edit || !data.prod_id
                            : !data.prod_id
                        }
                      />
                    </td>

                    {/* Finished Product Costing */}
                    <td>
                      <Form.Control
                        type="text"
                        value={formatToTwoDecimal(data.costing)}
                        className="form-control form-control-sm production-td-width p-2"
                        style={{ width: 80 }}
                        readOnly
                      />
                    </td>

                    {/* Finished Product UOM */}
                    <td className="p-0">
                      <input
                        type="text"
                        value={data.prod_uom}
                        readOnly
                        className="form-control form-control-sm p-2 production-td-width"
                      />
                    </td>

                    {/* Finished Product Delete Button */}
                    <td>
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => deleteFinishedProduct(index)}
                        disabled={
                          edit !== undefined
                            ? finishedProductRows?.length === 1 || !edit
                            : finishedProductRows?.length === 1
                        }
                      >
                        <i className="fa-solid fa-xmark"></i>
                      </button>
                    </td>
                  </tr>
                </Fragment>
              );
            })}
          </tbody>
        </table>
      </div>

      <div
        className={`w-100 ${edit !== undefined && !edit ? "d-none" : ""} d-flex justify-content-end mt-2 p-1`}
      >
        <button
          className="btn btn-primary btn-sm"
          type="button"
          onClick={addNewItemFinishProduct}
        >
          New Item
        </button>
      </div>
      {/* <div className="d-flex gap-4 mt-2 text-white flex-row justify-content-evenly px-3 total-amount-container-production align-items-center rounded">
            <div>
              <p className="mb-0">
                Total Produce:{" "}
                <span>
                  {finishedTotalWeight.toLocaleString("en-US", {
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2,
                  })}
                </span>
              </p>
            </div>
            <div>
              <p className="mb-0">
                Total Costing:{" "}
                <span>
                  {finishedTotalCosting.toLocaleString("en-US", {
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2,
                  })}
                </span>
              </p>
            </div>
          </div> */}
    </div>
  );
};

export default ProductionFinishedCreateTable;
